import {Button, Stack, Typography} from '@mui/material';
import {AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {ModalErrorTimeoutProps} from './types';
import {SendMessagePageEnum} from '../../../../../../../tests/constants/HelpPageEnum';

const {
	modalErrorTimeout: {titleModal, title, description, buttonGoBack},
} = translations['pt-br'].privateFlow.help.sendYourMessage;

export function ModalErrorTimeout({open, onBack}: ModalErrorTimeoutProps) {
	return (
		<AlertModal
			data-testid={SendMessagePageEnum.SEND_MESSAGE_TIMEOUT}
			open={open}
			onClose={onBack}
			variant="info"
			customIconName="timelapse-filled"
			headerTitle={titleModal}
			title={title}
			customMaxWidth={420}
			subDescription={
				<Typography fontWeight={400} textAlign={'center'}>
					{description}
				</Typography>
			}
			footerContent={
				<Stack width={'100%'}>
					<Button onClick={onBack} size="large">
						{buttonGoBack}
					</Button>
				</Stack>
			}
		/>
	);
}
